import { useEffect, useState } from "react";
import "./index.css";

const RemoveItemModal = ({ show, onClose, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setTimeout(() => setIsTransitioning(true), 100);
    } else {
      setIsTransitioning(false);
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!isVisible) {
    return null;
  }

  const overlayClickHandler = (e) => {
    e.stopPropagation();
    e.target === e.currentTarget && onClose();
  };

  return (
    <div
      className={`modal-overlay ${isTransitioning ? "show" : ""}`}
      onClick={overlayClickHandler}
    >
      <div className={`modal ${isTransitioning ? "show" : ""}`}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

export default RemoveItemModal

